"use strict";
import Common from "./Common";

export default class SplashScene extends P3.Scene {
    constructor() {
        super();
    }

    init() {

    }

    start() {

    }

    end() {
        this._running = false;
        this.signals.next.dispatch(this);
    }

    update() {

    }

    destroy() {
        TweenMax.killAll();
        super.destroy();
    }

    resize() {

    }
}

